// extracted by mini-css-extract-plugin
export var heroImage = "_c0-1";
export var modal = "_c0-0";